export default __webpack_public_path__ + "static/media/yellow-shop.912140e7.png";